export const FIXED_HUAPU_LINK = {
  enabled: true,
  icon: '/images/huapu-logo.jpg',
  name: '华谱（西安）生物科技有限公司',
  url: 'https://company.huapubio.com.cn/',
  order: 1
};

export function getFixedHuapuLink() {
  return { ...FIXED_HUAPU_LINK };
}

export function normalizeRelatedLinksData(data = {}) {
  const links = Array.isArray(data.links) ? data.links : [getFixedHuapuLink()];
  return {
    ...data,
    links
  };
}
